// Module
var code = "<template><div class=\"rich-text-editor\" ref=\"editor\"></div></template>";
// Exports
module.exports = code;